import { render, staticRenderFns } from "./segments-column.vue?vue&type=template&id=141e74d4&"
import script from "./segments-column.vue?vue&type=script&lang=js&"
export * from "./segments-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports